document.addEventListener("DOMContentLoaded", function() {
    const stepsSwiper = new Swiper(".how-to-2 .mySwiper", {
      direction: 'horizontal',
      navigation: {
        nextEl: ".how-to-2 .swiper-button-next",
        prevEl: ".how-to-2 .swiper-button-prev",
      },
      pagination: {
        el: ".how-to .swiper-pagination",
        clickable: true,
      },
      slidesPerView: 1, 
      breakpoints: {
          749: {
            slidesPerView: 3,
            spaceBetween: 20
          }
        },
    });
  });
  